import type { MenuConfig } from '~typings/menu'

import permisosInventario, { RESOURCE_INVENTARIO } from '@/auth/permissions/modules/inventario'
import * as names from '@routes/inventario-consumo/nombres/informes'

const { informes } = permisosInventario

export default [
    {
        title: 'inventario.subopciones.kardex',
        route: names.ROUTE_KARDEX,
        resource: RESOURCE_INVENTARIO,
        action: informes.kardex,
    },
    {
        title: 'inventario.subopciones.stock_inventario',
        route: names.ROUTE_ESTADO_INVENTARIO,
        resource: RESOURCE_INVENTARIO,
        action: informes.estadoInventario,
    },
    {
        title: 'inventario.subopciones.movimiento_inventario',
        route: names.ROUTE_MOVIMIENTO_INVENTARIO,
        resource: RESOURCE_INVENTARIO,
        action: informes.movimientoInventario,
    },
    {
        title: 'inventario.subopciones.stock_minimo',
        route: names.ROUTE_STOCK_MINIMO,
        resource: RESOURCE_INVENTARIO,
        action: informes.stockMinimo,
    },
    {
        title: 'inventario.subopciones.resumen_inventario',
        route: names.ROUTE_RESUMEN_INVENTARIO,
        resource: RESOURCE_INVENTARIO,
        action: informes.resumenInventario,
    },
    {
        title: 'inventario.subopciones.nota-ingreso-egreso',
        route: names.ROUTE_NOTA_INGRESO_EGRESO,
        resource: RESOURCE_INVENTARIO,
        action: informes.notaIngresoEgreso,
    },
    {
        title: 'inventario.subopciones.informe-reposicion',
        route: names.ROUTE_INFORME_REPOSICION,
        resource: RESOURCE_INVENTARIO,
        action: informes.informeReposicion,
    },
    {
        title: 'inventario.subopciones.toma-inventario',
        route: names.ROUTE_TOMA_INVENTARIO,
        resource: RESOURCE_INVENTARIO,
        action: informes.tomaInventario,
    },
    // {
    //     title: 'inventario.subopciones.rotacion-inventario',
    //     route: names.ROUTE_ROTACION_INVENTARIO,
    //     resource: RESOURCE_INVENTARIO,
    //     action: informes.rotacionInventario,
    // },
    // {
    //     title: 'inventario.subopciones.movimiento-inventario-general',
    //     route: names.ROUTE_MOVIMIENTO_INVENTARIO_GENERAL,
    //     resource: RESOURCE_INVENTARIO,
    //     action: informes.movimientoInventarioGeneral,
    // },
    {
        title: 'inventario.subopciones.movimiento-transferencias-automaticas',
        route: names.ROUTE_MOVIMIENTO_TRANSFERENCIAS_AUTOMATICAS,
        resource: RESOURCE_INVENTARIO,
        action: informes.movimientoTransferenciasAutomaticas,
    },
    {
        title: 'inventario.subopciones.rotacion-antiguedad-inventario',
        route: names.ROUTE_ROTACION_ANTIGUEDAD_INVENTARIO,
        resource: RESOURCE_INVENTARIO,
        action: informes.rotacionAntiguedadInventario,
    },
    // {
    //     title: 'inventario.subopciones.estado-inventario-rotacion',
    //     route: names.ROUTE_ESTADO_INVENTARIO_ROTACION,
    //     resource: RESOURCE_INVENTARIO,
    //     action: informes.estadoInventarioRotacion,
    // },
    {
        title: 'inventario.subopciones.politicas_item',
        route: names.ROUTE_POLITICAS_ITEM,
        resource: RESOURCE_INVENTARIO,
        action: informes.politicasItem,
    },
] as MenuConfig[]
